import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';


@Component({
    selector: 'app-delete-treatment',
    templateUrl: './delete-treatment.component.html',
    styleUrl: './delete-treatment.component.scss',
    standalone: false
})
export class DeleteTreatmentComponent {
  
  constructor(
    public dialogRef: MatDialogRef<DeleteTreatmentComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    dialogRef.disableClose = true;
  }

  deleteTreatment(): void {
    this.dialogRef.close(true);
  }

  close(): void {
    this.dialogRef.close(false);
  }
}